export default "__VITE_ASSET__Bkh7kLK___"